module.exports = __webpack_public_path__ + "static/bellur_img-02b39ea40581ee185deec08ac4950cab.jpg";